import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
export function CountdownTimer() {
  // Fake countdown logic for demo purposes
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 54,
    seconds: 39
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-8 px-4 max-w-3xl mx-auto space-y-[32px]" data-id="element-87">
      <FadeIn data-id="element-88">
        <div className="text-center mb-6" data-id="element-89">
          <h2 className="text-2xl font-bold text-gray-300 flex items-center justify-center gap-2" data-id="element-90">
            <span className="text-2xl" data-id="element-91">⏰</span> PRECIO DE LANZAMIENTO
          </h2>
        </div>

        <div className="bg-gray-900 border-2 border-red-900/50 rounded-2xl p-8 text-center relative overflow-hidden" data-id="element-92">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500 via-orange-500 to-red-500" data-id="element-93"></div>

          <div className="flex justify-center items-center gap-2 md:gap-4 text-4xl md:text-6xl font-black font-mono mb-6 text-white" data-id="element-94">
            <div className="bg-black px-4 py-3 rounded-lg border border-gray-800 min-w-[80px] md:min-w-[100px]" data-id="element-95">
              {formatTime(timeLeft.hours)}
            </div>
            <span className="text-gray-600 pb-2" data-id="element-96">:</span>
            <div className="bg-black px-4 py-3 rounded-lg border border-gray-800 min-w-[80px] md:min-w-[100px]" data-id="element-97">
              {formatTime(timeLeft.minutes)}
            </div>
            <span className="text-gray-600 pb-2" data-id="element-98">:</span>
            <div className="bg-black px-4 py-3 rounded-lg border border-gray-800 min-w-[80px] md:min-w-[100px] text-red-400" data-id="element-99">
              {formatTime(timeLeft.seconds)}
            </div>
          </div>

          <div className="space-y-4" data-id="element-100">
            <p className="text-lg md:text-xl font-bold text-yellow-500 flex items-center justify-center gap-2" data-id="element-101">
              <AlertTriangle size={24} data-id="element-102" />
              Después sube $10.000 ARS. No vuelve.
            </p>

            <div className="max-w-md mx-auto" data-id="element-103">
              <div className="flex justify-between text-sm font-medium mb-2 text-gray-400" data-id="element-104">
                <span className="flex items-center gap-1.5" data-id="element-105">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-106"></span>{' '}
                  Cupos tomados
                </span>
                <span data-id="element-107">71%</span>
              </div>
              <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-108">
                <div className="bg-gradient-to-r from-red-600 to-red-500 h-3 rounded-full" style={{
                width: '71%'
              }} data-id="element-109"></div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}